export const ManifestJobTabKeys = {
    OVERVIEW: 'overview',
    DOCUMENTS: 'documents',
    NOTES: 'notes',
    HISTORY: 'history',
    INVOICES: 'invoices',
} as const;

export type ManifestJobTabKey = typeof ManifestJobTabKeys[keyof typeof ManifestJobTabKeys];
